import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "text-gray-400 whitespace-pre-line leading-relaxed break-words overflow-wrap-anywhere" }
const _hoisted_3 = { class: "bg-gray-700 bg-opacity-50 rounded-lg p-3 mb-6 shadow-inner" }
const _hoisted_4 = { class: "text-white font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-300 mb-2" }, "Opis proizvoda", -1)),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.product.description), 1)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-t border-gray-700 my-4" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-sm text-gray-400" }, "Postavljen", -1)),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.formatDate(_ctx.product.renewedAt || _ctx.product.createdAt)), 1)
    ])
  ]))
}